import { React, useState, useEffect } from "react";
import styles from "./HttpsSetup.module.scss";
import useErrorContext from "../../../../utils/useErrorContext";
import { useHistory } from "react-router";
import GenerateCertificate from "./GenerateCertificate";
import InstallCertificate from "./InstallCertificate";
import { useSelector, useDispatch } from "react-redux";
import ShowCertificate from './ShowCertificate'
import { Redirect, Route, Switch } from "react-router-dom";
import { Layout, RadioButton, CardRadioGroup, MainLoader, Text, Heading, Breadcrumbs } from "@netapp/bxp-design-system-react";
import { useTranslation } from 'react-i18next';
import { connectorsettings as i18nNamespace } from "../../../../i18n/namespace";
import { Link } from "react-router-dom";

const SetUpHttps = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const showInstalledCertificate = useSelector(state => state.connectorSettings.https.showInstalledCertificate);
    const [generate, setGenerate] = useState(true);
    const { t } = useTranslation(i18nNamespace);
    const agentId = useSelector(state => state.tenancy.selectedAgentId);

    const updateContainer = () => {
        setGenerate(!generate);
    };
    useEffect(() => {
        if (showInstalledCertificate) {
            dispatch({
                type: "CONNECTOR-SETTINGS:REMOVE-NAVIGATE-TO-SHOW-CERTIFICATE",
            });
            history.push(`/agents-mgmt/${agentId}/https-setup/certificate`);
        }
    }, [showInstalledCertificate, dispatch, history])
    return (
        <>
            <Breadcrumbs className={styles["breadcrumbs"]}>
                <Link to="/agents-mgmt">{t("overview")}</Link>
                <div>{t("https_setup")}</div>
            </Breadcrumbs>
            <div className={styles["base"]}>
                <Heading level={24}>{t("install_http_certificate")}</Heading>
                <Text className={styles['text-setup']}>{t("install_http_certificate_desc")}</Text>

                <CardRadioGroup labelStyle={{ fontSize: 16, fontWeight: 'normal', marginRight: 32 }} label={t("select_container_type")}>
                    <RadioButton onChange={updateContainer}
                        name="generate"
                        checked={generate}>
                        {t("generate_csr_request")}
                    </RadioButton>
                    <RadioButton onChange={updateContainer}
                        name="install"
                        checked={!generate}>
                        {t("install_ca_certificate")}
                    </RadioButton>
                </CardRadioGroup>


                {generate
                    ? <GenerateCertificate />
                    : <InstallCertificate />}
            </div>
        </>
    );
}


export default () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const certificateLoad = useSelector(state => state.connectorSettings.https.certificateLoad);
    const signedCertificate = useSelector(state => state.connectorSettings.https.signedCertificate);
    const agentId = useSelector(state => state.tenancy.selectedAgentId);

    if (!agentId) {
        // If a agentId is not specified, redirect to the agents management page
        history.push("/agents-mgmt");
    }

    useEffect(() => {

        history.push(`/agents-mgmt/${agentId}/https-setup/certificate`);
        dispatch({
            type: "CONNECTOR-SETTINGS:FETCH-HTTPS-CERTIFICATE"
        })
    }, [dispatch, agentId, history]);
    useErrorContext("HTTPS-SETUP");

    return <Layout.Page>
        <Layout.Content>
            <Layout.Container>
                {!certificateLoad ?
                    <Switch>
                        {signedCertificate &&
                            <Route exact path="/agents-mgmt/:agentId/https-setup/certificate" render={() => <ShowCertificate />} />}
                        <Route exact path="/agents-mgmt/:agentId/https-setup" render={() => <SetUpHttps />} />
                        <Redirect to={signedCertificate ? "/agents-mgmt/:agentId/https-setup/certificate" : "/agents-mgmt/:agentId/https-setup"} />
                    </Switch> : <MainLoader />}
            </Layout.Container>
        </Layout.Content>
    </Layout.Page>
};